import api from './api';

const BASE = '/inspecciones';

// Descarga el PDF del reporte directamente en el navegador
export const descargarReportePDF = async (sesion = null) => {
    const params = sesion ? { sesion } : {};
    const response = await api.get(`${BASE}/reporte/descargar`, {
        params,
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `inspeccion_${sesion || 'actual'}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

// Descarga el Excel del reporte (con evidencias fotográficas) directamente en el navegador
export const descargarReporteExcel = async (sesion = null) => {
    const params = sesion ? { sesion } : {};
    const response = await api.get(`${BASE}/reporte/descargar-excel`, {
        params,
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `inspeccion_${sesion || 'actual'}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

// Genera la clave de sesión quincenal actual en el frontend (coincide con backend)
export const sesionActual = () => {
    const ahora = new Date();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const quincena = ahora.getDate() <= 15 ? 'Q1' : 'Q2';
    return `${ahora.getFullYear()}-${mes}-${quincena}`;
};

export const inspeccionesService = {
    // Checklist completo: preguntas + última respuesta de la sesión
    checklist: async (sesion = null) => {
        const params = sesion ? { sesion } : { sesion: sesionActual() };
        const response = await api.get(`${BASE}/checklist`, { params });
        return response.data;
    },

    // Listar solo preguntas
    listarPreguntas: async (soloActivas = true) => {
        const response = await api.get(`${BASE}/preguntas`, { params: { solo_activas: soloActivas } });
        return response.data;
    },

    // Agregar pregunta
    crearPregunta: async (texto, descripcion = null, orden = 0) => {
        const response = await api.post(`${BASE}/preguntas`, { texto, descripcion, orden });
        return response.data;
    },

    // Editar pregunta
    actualizarPregunta: async (id, datos) => {
        const response = await api.put(`${BASE}/preguntas/${id}`, datos);
        return response.data;
    },

    // Eliminar pregunta
    eliminarPregunta: async (id) => {
        const response = await api.delete(`${BASE}/preguntas/${id}`);
        return response.data;
    },

    // Marcar OK rápido
    marcarOk: async (preguntaId, sesion = null) => {
        const params = { sesion: sesion || sesionActual() };
        const response = await api.post(`${BASE}/preguntas/${preguntaId}/ok`, null, { params });
        return response.data;
    },

    // Enviar reporte por email
    enviarReporte: async (email, sesion = null) => {
        const response = await api.post(`${BASE}/reporte/enviar`, {
            email,
            sesion: sesion || null,
        });
        return response.data;
    },

    // Responder con texto y estado
    responder: async (preguntaId, respuesta, estado = 'ok', sesion = null) => {
        const params = {
            respuesta,
            estado,
            sesion: sesion || sesionActual(),
        };
        const response = await api.post(`${BASE}/preguntas/${preguntaId}/responder`, null, { params });
        return response.data;
    },

    // Historial de sesiones quincenales (con filtros opcionales)
    historial: async ({ anio = null, mes = null, dia = null } = {}) => {
        const params = {};
        if (anio !== null && anio !== '') params.anio = anio;
        if (mes !== null && mes !== '') params.mes = mes;
        if (dia !== null && dia !== '') params.dia = dia;
        const response = await api.get(`${BASE}/historial`, { params });
        return response.data;
    },
};
